import { Component, OnInit } from '@angular/core';
import { InventoryActionTableComponent } from '../inventory-action-table/inventory-action-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { SttTableService } from '../../../../shared/components/stt-table/stt-table-service';

@Component({
    selector: 'app-inventory-raw-materials',
    templateUrl: './inventory-raw-materials.component.html',
    styleUrls: ['./inventory-raw-materials.component.scss']
})
export class InventoryRawMaterialsComponent implements OnInit {
    public tableEndpoint = 'inventory';
    public tableActionComponent = InventoryActionTableComponent;
    public tableQuery: any;
    public ref: DynamicDialogRef;

    constructor(public dialogService: DialogService,
                public router: Router) {
        this.tableQuery = new SttTableService()
            .addInclude('fnc');
    }

    ngOnInit(): void {

    }
}
